import { StateAbbrv } from "../Configs/config";
import { formatNumber } from "../utils";

// Builds the human-readable, pipe-separated summary of an applied advanced-filter
// set (e.g. "Bed Count Max: 400 | Bed Count Min: 200"). Shared by FilterComp
// (applying filters via the panel) and LeftSection (deriving the title straight
// from the URL on a refresh / shared link) so both paths render identically.
//
// `filterObj` is keyed by the advanced form's own field names. `coc_accredited`
// may be either the form's { checked, value } object or the raw URL string.
export function generateTableTitle(filterObj = {}) {
  const titleParts = [];

  if (filterObj.state) {
    const stateFull = Object.keys(StateAbbrv).find(
      (key) => StateAbbrv[key] === filterObj.state,
    );
    if (stateFull) titleParts.push(`State: ${stateFull}`);
  }
  if (filterObj.county) {
    titleParts.push(
      `County: ${filterObj.county.charAt(0).toUpperCase() + filterObj?.county?.slice(1).toLowerCase()}`,
    );
  }
  if (filterObj.hospital_name) {
    titleParts.push(`Hospital: ${filterObj.hospital_name}`);
  }
  if (filterObj.urban_rural_flag) {
    titleParts.push(`Geography: ${filterObj.urban_rural_flag}`);
  }
  if (filterObj.zip_code) {
    titleParts.push(`ZIP Code: ${filterObj.zip_code}`);
  }
  if (filterObj.cbsa) {
    titleParts.push(`CBSA: ${filterObj.cbsa}`);
  }
  if (filterObj.facility_type) {
    titleParts.push(`Facility Type: ${filterObj.facility_type}`);
  }
  if (filterObj.prov_control_type) {
    titleParts.push(`Ownership: ${filterObj.prov_control_type}`);
  }
  if (filterObj.CALC_STATS_BEDS_TOTAL) {
    titleParts.push(`Total Beds: ${filterObj.CALC_STATS_BEDS_TOTAL}`);
  }
  if (filterObj.case_volume) {
    titleParts.push(`Case Volume: ${filterObj.case_volume}`);
  }
  // Accept both the form's { checked } object and a truthy raw URL value.
  const cocAccredited =
    filterObj.coc_accredited && typeof filterObj.coc_accredited === "object"
      ? filterObj.coc_accredited.checked
      : !!filterObj.coc_accredited;
  if (cocAccredited) {
    titleParts.push(`COC Accredited`);
  }
  if (filterObj.bed_count_max) {
    titleParts.push(`Bed Count Max: ${Math.floor(filterObj.bed_count_max)}`);
  }
  if (filterObj.bed_count_min) {
    titleParts.push(`Bed Count Min: ${Math.floor(filterObj.bed_count_min)}`);
  }
  if (filterObj.square_footage_max) {
    titleParts.push(
      `Square Footage Max: ${Math.floor(filterObj.square_footage_max)}`,
    );
  }
  if (filterObj.square_footage_min) {
    titleParts.push(
      `Square Footage Min: ${Math.floor(filterObj.square_footage_min)}`,
    );
  }
  if (filterObj.patient_discharge_max) {
    titleParts.push(
      `Patient Discharge Max: ${Math.floor(filterObj.patient_discharge_max)}`,
    );
  }
  if (filterObj.patient_discharge_min) {
    titleParts.push(
      `Patient Discharge Min: ${Math.floor(filterObj.patient_discharge_min)}`,
    );
  }
  if (filterObj.net_income_margin_max) {
    titleParts.push(
      `Net Income Margin Max: ${Math.floor(filterObj.net_income_margin_max)}`,
    );
  }
  if (filterObj.net_income_margin_min) {
    titleParts.push(
      `Net Income Margin Min: ${Math.floor(filterObj.net_income_margin_min)}`,
    );
  }
  if (filterObj.operating_margins_max) {
    titleParts.push(
      `Operating Margins Max: ${Math.floor(filterObj.operating_margins_max)}`,
    );
  }
  if (filterObj.operating_margins_min) {
    titleParts.push(
      `Operating Margins Min: ${Math.floor(filterObj.operating_margins_min)}`,
    );
  }
  if (filterObj.net_patient_revenue_max) {
    titleParts.push(
      `Net Patient Revenue Max: ${formatNumber(`${Math.floor(filterObj.net_patient_revenue_max * 1000000)}`)}`,
    );
  }
  if (filterObj.net_patient_revenue_min) {
    titleParts.push(
      `Net Patient Revenue Min  : ${formatNumber(`${Math.floor(filterObj.net_patient_revenue_min * 1000000)}`)}`,
    );
  }
  return titleParts.length > 0 ? titleParts.join(" | ") : "All Hospitals";
}
